import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

import { dwmRole } from '../../shared/enums/roles';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean> => {
  const { authenticated, grantedRoles, keycloak } = authData;

  // Force the user to log in if currently unauthenticated.
  if (!authenticated) {
    await keycloak.login({
      redirectUri: globalThis.location.origin + state.url
    });
    return false;
  }

  // Get the roles required from the route.
  const requiredRoles = route.data['roles'];

  // Get all roles from realm and resource roles
  const allRoles = new Set([
    ...Object.values(grantedRoles.resourceRoles).flat(),
    ...grantedRoles.realmRoles
  ]);

  // Allow the user to proceed if no additional roles are required to access the route.
  if (!Array.isArray(requiredRoles) || requiredRoles.length === 0) {
    if (allRoles.has(dwmRole.SUPERADMIN) && state.url === '/') {
      const router = inject(Router);
      router.navigate(['/admin']);
      return false;
    }
    return true;
  }

  // Allow the user to proceed if any the required roles are present.
  return requiredRoles.some((role) => allRoles.has(role));
};

export const AuthGuard: CanActivateFn = createAuthGuard(isAccessAllowed);
